<template>
  <base-button
    class="w-full flex gap-2 bg-grey-90 px-2 py-4 underlined"
    @click="emit('click')"
  >
    <vf-icon size="md" src="https://assets.vans.eu/image/upload/v1768557172/vans-bag.svg" />
    {{ $t.reserveInStore }}
  </base-button>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  click: []
}>()
</script>
